<template>
    <div class="container">
        <card
            header-text="Importar archivo CSV de cargue masivo"
            class="col-md-8 offset-md-2">
            <div class="card-body card-block">
                <div class="container">
                    <input @change="handleFileChange" type="file"/>
                </div>
                <button class="btn btn-block btn-info mt-5" @click="readFile">Cargar CSV</button>
            </div>
        </card>
    </div>
</template>
<script>
import { cargarCSVCargueMasivo } from '../../api/admin'
import { saveAs } from 'file-saver'

export default {
  data: function () {
    return {
      availability: {}
    }
  },
  methods: {
    handleFileChange () {
      this.file = event.target.files[0]
    },
    readFile () {
      if (!this.file) {
        alert('No se ha seleccionado un archivo')
        return
      }
      /* return first object in FileList */
      this.$papa.parse(this.file, {
        header: false,
        delimiter: '\t',
        encoding: 'utf-8',
        complete: function (results) {
          this.availability = results.data
          this.availability = this.availability.reduce((a, b, i) => {
            if (i === 0) return []
            if (!b[0]) return a
            return [...a, {
              'MUNICIPIO': b[0],
              'Voluntario (X)': b[1],
              'Inspirado(X)': b[2],
              'Nombres': b[3],
              'Apellidos': b[4],
              'Tipo de documento': b[5],
              'Número de identidad': b[6],
              'Edad': b[7],
              'Nacionalidad': b[8],
              'Teléfono': b[9],
              'Sexo': b[10],
              'Minoría étnica': b[11],
              'Víctima (X)': b[12],
              'Discapacidad (X)': b[13],
              'LGTBI (X)': b[14],
              'Correo electrónico': b[15],
              'Dirección': b[16],
              'Tipo de organización': b[17],
              'Nombre organización': b[18],
              'Oficial Campo': b[19],
              'Voluntario': b[20]
            }]
          }, [])

          cargarCSVCargueMasivo(this.availability)
            .then((res) => {
              console.log(res)
              if (res.status === 200) {
                alert('Operación exitosa')
                res.blob()
                  .then((blob) => {
                    console.log(blob)
                    saveAs(blob, `resultadosCargueMasivo-${Date.now()}.csv`)
                    // const downloadLink = document.createElement('a')
                    // const blob = new Blob(['\ufeff', res.data])
                    // const url = URL.createObjectURL(blob)
                    // downloadLink.href = url
                    // downloadLink.download = "data.csv"
                    // document.body.appendChild(downloadLink)
                    // downloadLink.click()
                    // document.body.removeChild(downloadLink)
                  })
              }
              // console.log(res)
            })
            .catch((err) => {
              console.error(err)
            })
        }
      })
    }
  }
}
</script>
